module.exports = __webpack_public_path__ + "img/红旗.64f8e9ef.png";